export const products = [
  {
    id: 1,
    img: "https://raw.githubusercontent.com/carlosaw/portfolio/master/src/img/aw.png",
    link: "https://awregulagens.com.br",
  },
  {
    id: 2,
    img: "https://raw.githubusercontent.com/carlosaw/portfolio/master/src/img/nova-loja.png",
    link: "http://awregulagens.com.br/nova_loja",
  },
  {
    id: 3,
    img: "https://raw.githubusercontent.com/carlosaw/portfolio/master/src/img/contaazul.png",
    link: "http://awregulagens.com.br/contaazul",
  },
  {
    id: 4,
    img: "https://raw.githubusercontent.com/carlosaw/portfolio/master/src/img/pizza.png",
    link: "https://carlosaw.github.io/pizza/",
  },
  {
    id: 5,
    img: "https://raw.githubusercontent.com/carlosaw/portfolio/master/src/img/awBlack.png",
    link: "https://next-js-aw.vercel.app/",
  },
  {
    id: 6,
    img: "https://raw.githubusercontent.com/carlosaw/netflixclone/master/netflixclone.png",
    link: "http://awregulagens.com.br/netflixclone/",
  },
];